import reducers from './reducers';

import * as authOperations from './operations';
import * as authSelectors from './selectors';
import * as authTypes from './types';

export { authOperations, authSelectors, authTypes };

export default reducers;
